// extracted by mini-css-extract-plugin
export var errorIcon = "_oa-1";
export var nameLogo = "_oa-0";